import i18next from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import moment from 'moment';

function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
}

i18next
  .use(XHR)
  .use(LanguageDetector)
  .init({
    lng: 'es',
    initImmediate: false,
  });

i18next.init({
  interpolation: {
    format(value, format, lng) {
      if (format === 'capitalize' && typeof value === 'string') {
        return value.charAt(0).toUpperCase() + value.substr(1);
      }
      if (value instanceof Date) return moment(value).format(format);
      return value;
    },
  },
});

requireAll(require.context('..', true, /i18n\.js$/));

export default i18next;



// WEBPACK FOOTER //
// ./src/config/i18n.js